<template>
  <v-expansion-panel expand>
    <v-expansion-panel-content value="true">
      <div slot="header">
        <v-layout row align-center justify-start>
          <v-flex xs6>
            <strong>{{this.documentType}}</strong>
            <span class="badge grey darken-1 mx-1" v-if="this.remainingDocuments !== 0">
              {{this.remainingDocuments}} restantes
            </span>
            <template v-if="type === 'intimation'">
              <span class="badge green darken-1 mx-1" v-if="this.viewedAt">
                Visualizado em {{ viewedAt | formatDate2 }}
              </span>
              <span class="badge red darken-1 mx-1" v-else>
                Não visualizado
              </span>
            </template>
          </v-flex>

          <v-layout justify-space-around align-center>
            <v-flex xs7>
              <v-progress-linear v-model="this.progressRemaingDocuments"/>
            </v-flex>
            <strong class="primary--text">
              {{Math.round(this.progressRemaingDocuments)}}% ANALISADO
            </strong>
          </v-layout>
        </v-layout>
      </div>

      <v-card class="grey lighten-4 document-list">
        <v-card-text>
          <v-card subheader v-for="document in documents" :key="document.id">

            <v-layout class="py-3"
                      v-if="document.last_document_version"
                      row wrap>
              <v-flex class="text-xs-center" xs1>
                <v-icon>mdi-file mdi-24px</v-icon>
              </v-flex>

              <v-flex xs11 class="text-justfy pr-4">
                <span class="font-weight-bold">
                  {{ document.document_intimation === null ?
                  document.document_type.name :
                  document.document_intimation.document_name }}
                </span>

                <v-layout v-if="isAdmin" row wrap>
                  <v-btn v-if="document.last_document_version.status !== 'awaiting_review'
                              && document.last_document_version.mime_type === 'application/pdf'
                              "
                          class="mb-1 ml-0"
                          small outline
                          color="primary"
                          @click="loadFile(document)">
                    <v-icon left>mdi-eye</v-icon>
                    Visualizar
                  </v-btn>
                  <v-btn v-if="locked !== null &&
                                document.last_document_version.status !== 'waiting_to_be_sent'"
                          class="mb-1"
                          small outline
                          color="primary"
                          @click="downloadFile(document)">
                    <v-icon left>mdi-download</v-icon>
                    Download
                  </v-btn>
                  <undo-analysis-component
                    :application="application" 
                    :document="document"
                    v-if="showUndoAnalysis(document)"
                  />
                  <v-btn small color="primary"
                          v-if="locked !== null &&
                                document.last_document_version.status === 'awaiting_review'"
                          @click="loadFile(document)">
                    <v-icon left>mdi-eye</v-icon>
                    Analisar
                  </v-btn>
                </v-layout>
              </v-flex>

            </v-layout>

            <template v-if="checkDocumentChip(document)">
              <v-divider class="mx-4"/>

              <v-layout class="my-3" v-if="document.last_document_version.status !== 'disapproved_by_reviewer'">
                <v-spacer/>
                <v-flex xs11>
                  <span class="badge"
                    v-bind:style="documentChipColor(document)">
                      {{documentChipText(document)}}
                  </span>

                  <span class="caption grey--text ml-2" v-if="document.last_document_version.status === 'approved'">
                    {{ document.last_document_version.updated_at | formatDateTime }}
                  </span>
                </v-flex>
              </v-layout>
            </template>

            <template v-if="document.refusals.length">
              <v-divider class="mx-4"/>
              <v-layout
                class="my-3"
                v-for="(doc, index) in document.refusals"
                :key="doc.id"
              >
                <v-spacer/>
                <v-flex xs11>
                  <span class="badge error">Reprovado</span>

                  <span class="caption grey--text ml-2">
                    {{ doc.updated_at | formatDateTime }}
                  </span>
                  
                  <div class="my-2">
                    <strong>Motivo da reprovação:</strong>
                    <span class="grey--text ml-2">{{doc.reason}}</span>
                  </div>

                  <v-divider class="mr-4" v-if="index + 1 != document.refusals.length"/>
                </v-flex>
              </v-layout>
            </template>

            <v-divider/>
          </v-card>

        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>

</template>

<script>

import colors from 'vuetify/es5/util/colors';
import UndoAnalysisComponent from '@/components/application/show/undo_analysis/UndoAnalysisComponent';
import EventBus from '@/utils/event_bus';
import axios from 'axios'

export default {
  name: 'ExpansionPanelForDocuments',
  props: ['application', 'documents', 'documentType', 'viewedAt', 'category', 'isAdmin', 'locked', 'type'],
  components: {
    UndoAnalysisComponent,
  },
  data() {
    return {
      titlePopover: false,
      isUploading: false,
    };
  },
  methods: {
    checkDocumentChip(document) {
      if (document.last_document_version == null) {
        return false;
      }

      return ['disapproved_by_reviewer', 'disapproved_by_creator', 'approved']
        .indexOf(document.last_document_version.status) !== -1;
    },
    documentChipColor(document) {
      if (document.last_document_version == null || document.last_document_version.status === 'waiting_to_be_sent'
        || document.last_document_version.status === 'awaiting_review') {
        return { background: colors.blue.darken2, color: 'white' };
      } else if (document.last_document_version.status === 'disapproved_by_reviewer'
        || document.last_document_version.status === 'disapproved_by_creator') {
        return { background: colors.red.base, color: 'white' };
      }
      return { background: colors.green.base, color: 'white' };
    },
    documentChipText(document) {
      if (document.last_document_version == null || document.last_document_version.status === 'waiting_to_be_sent') {
        return 'Aguardando Envio';
      } else if (document.last_document_version.status === 'awaiting_review') {
        return 'Enviado';
      } else if (document.last_document_version.status === 'disapproved_by_reviewer'
        || document.last_document_version.status === 'disapproved_by_creator') {
        return 'Reprovado';
      }
      return 'Aprovado';
    },
    loadFile(document) {
      EventBus.$emit('pdf-selected', {
        documentSelected: document,
        application: this.application,
      });
    },

    dumpFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    downloadFile(document) {
      const url = document.last_document_version.document_path.url;
      const filename = url.split('?').shift().split('/').pop();

      axios({ method: 'get', url, responseType: 'arraybuffer',})
        .then((response) => {
          this.dumpFileDownload(response, filename)
        })
        .catch((response) => {
          this.$emit('document-errored', { text: 'Falha ao carregar o documento.', response });
        });
    },
    showUndoAnalysis(document) {
      return document.last_document_version.status === 'approved'
              || document.last_document_version.status === 'disapproved_by_reviewer';
    },

  },
  computed: {
    remainingDocuments() {
      return this.documents.reduce((prev, elem) => {
        if (!elem.last_document_version) {
          return prev + 1;
        }
        else if (elem.last_document_version.status === 'awaiting_review' &&
          elem.document_type.category === this.category) {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
    progressRemaingDocuments() {
      if (this.remainingDocuments === 0) {
        return 100;
      }
      return (1 - (this.remainingDocuments / this.documents.length)) * 100;
    },
  },
};
</script>

<style scoped="true">
  .text-justfy {
    text-align: justify;
  }
</style>
